import { render, staticRenderFns } from "./news15.vue?vue&type=template&id=2adcbcf4&scoped=true&"
import script from "./news15.vue?vue&type=script&lang=js&"
export * from "./news15.vue?vue&type=script&lang=js&"
import style0 from "./news15.vue?vue&type=style&index=0&id=2adcbcf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adcbcf4",
  null
  
)

export default component.exports